/* eslint-disable camelcase */
import React, { useState } from 'react'
import Container from '../container/Container'

import Header from './header/Header'
import Table from './table/Table'
import { HistoryProps } from './interfaces'
import SFXS from '../../assets/audios/audios'

export default function History({
  unBlur,
  handleAbove,
  history,
  // toFix,
  user_id,
  handleNotification,
  colors,
  requestBetReply,
  setRoundId,
  audio,
  betAmount,
  multiplier,
  payout,
  grid,
  maxWidth,
}: HistoryProps) {
  const { tabSFX } = SFXS
  tabSFX.volume = audio.volume

  const [active, setactive] = useState('my')

  history = history[active]

  const handleActive = (e: any) => {
    if (audio.sound && active !== e) {
      tabSFX.load()
      tabSFX.play()
    }
    setactive(e)
  }

  return (
    <Container
      textColor={colors.primary}
      backgroundColor={colors.secondaryBackground}
      unBlur={unBlur}
    >
      <Header
        active={active}
        handleActive={handleActive}
        colors={colors}
        audio={audio}
        handleAbove={handleAbove}
      />
      <Table
        array={history}
        user_id={user_id}
        // toFix={toFix}
        handleAbove={handleAbove}
        handleNotification={handleNotification}
        strokeColor={colors.primary}
        requestBetReply={requestBetReply}
        setRoundId={setRoundId}
        audio={audio}
        betAmount={betAmount}
        multiplier={multiplier}
        payout={payout}
        grid={grid}
        maxWidth={maxWidth}
      />
    </Container>
  )
}
